import gql from 'not-graphql-tag';

export const managePerRelationship = gql`
  mutation managePerRelationship($payload: managePerRelationshipInput!) {
    managePerRelationship(payload: $payload) {
      encryptedParentPerId
      authDriverList {
        personId
        opConnectEmail
        isOpConnectEmailAvailable
        chargePointEmail
        isChargePointEmailAvailable
        accessCode
        chargePointstatus
        opConnectStatus
        accessCode
        errorReason
      }
    }
  }
`;

export const getChargePointDetails = gql`
  query GetChargePointPersons($params: managePerRelationshipInput!) {
    getChargePointPersons(params: $params) {
      authDriverList {
        personId
        opConnectEmail
        isOpConnectEmailAvailable
        chargePointEmail
        isChargePointEmailAvailable
        accessCode
        chargePointstatus
        opConnectStatus
      }
    }
  }
`;

export const mutationChargePoint = gql`
  mutation ManagePerRelationship($payload: managePerRelationshipInput!) {
    managePerRelationship(payload: $payload) {
      accessCode
      chargePointEmail
      isChargePointEmailAvailable
      opConnectEmail
      isOpConnectEmailAvailable
      authDriverList {
        accessCode
        encryptedPersonId
        endDate
        isSuccess
        startDate
      }
    }
  }
`;
